export default __webpack_public_path__ + "static/icomoon-bfcc1554849b4a11e26f96425dcee6a2.svg";